/**
 * m(i, j) = m(i+1, j+1), txt[i] == pattern[j]
 *              | m(i+1, j+1) || m(i+1, j), pattern[j] == '*'
 */
const starPattern = (txt, pattern) => {
  const dp = [];
  const m = txt.length,
    n = pattern.length;

  if (!txt || !pattern) return false;

  dp[m] = [];
  for (let i = 0; i < n; i++) {
    if (pattern[i] === '*') {
      dp[m][i] = true;
    } else {
      dp[m][i] = false;
    }
  }
  dp[m][n] = true;

  for (let i = m - 1; i >= 0; i--) {
    dp[i] = [];
    for (let j = n - 1; j >= 0; j--) {
      if (pattern[j] === '*') {
        dp[i][j] = dp[i + 1][j + 1] || dp[i + 1][j];
      } else if (txt[i] === pattern[j]) {
        dp[i][j] = dp[i + 1][j + 1];
      }
    }
  }

  return dp[0][0];
};

export {
  starPattern
};
